import { LoadingDialog } from '@/components/controls';
import {
  useDeleteUrgentAction,
  useUpsertUrgentAction,
  useUrgentAction,
} from '@/hooks';
import { useMemo } from 'react';
import { UrgentActionEditorDialog } from './UrgentActionEditorDialog';

export function UrgentActionEditor({ code, isOpen, onClose, groupCodes }) {
  const defaultUrgentAction = useMemo(
    () => ({
      groupCodes: groupCodes ?? [],
      occurrenceNumber: '',
      description: '',
      updates: [],
    }),
    [groupCodes],
  );
  const {
    query: { data: fetchedUrgentAction },
  } = useUrgentAction(code);
  const urgentAction =
    code === 'new' ? defaultUrgentAction : fetchedUrgentAction;
  const { mutateAsync: upsertUrgentAction } = useUpsertUrgentAction();
  const { mutate: deleteUrgentAction, isPending: isDeleting } =
    useDeleteUrgentAction();

  async function handleClose(values) {
    if (values) {
      await upsertUrgentAction(values);
    }

    onClose();
  }

  function handleDelete() {
    deleteUrgentAction(code);

    onClose();
  }

  return urgentAction ? (
    <UrgentActionEditorDialog
      urgentAction={urgentAction}
      isOpen={isOpen}
      onClose={handleClose}
      onDelete={handleDelete}
      isDeleting={isDeleting}
    />
  ) : (
    <LoadingDialog isOpen={isOpen} />
  );
}
